'use client';

import dynamic from 'next/dynamic';
import { Locale, countryLanguages, defaultLanguage } from 'shared/src/types/languages.type';
import { useParams } from 'next/navigation';
import { FooterClient } from '@/components/footer-client';
import { ThreeDotsLoading } from '@/components/loading/three-dots-loading';

const TopMenu = dynamic(() => import('../../../components/top-menu/top-menu'));

const Loading = () => {
  const params = useParams<{ lang: string }>();
  const lang = params.lang as Locale;
  const locale = countryLanguages[lang] ?? defaultLanguage;

  return (
    <>
      <TopMenu locale={locale} noTitle loadingScreen />
      <ThreeDotsLoading />
      <FooterClient lang={locale} hideAiDisclosure hideReport />
    </>
  );
};

export default Loading;
